jQuery(document).ready(function ($) {
    // Bundle se načítá na všech stránkách – bez formuláře nemá handler co dělat.
    let newsletter_form = document.getElementById('newsletter-form');
    if (!newsletter_form) {
        return;
    }

    let alert_msg = $('#newsletter-alert-message');
    alert_msg.hide();

    function showAlertMessage(message, isSuccess = true) {
        alert_msg.find('.alert-message').text(message);

        if (isSuccess) {
            alert_msg.removeClass('alert-danger').addClass('alert-success');
        } else {
            alert_msg.removeClass('alert-success').addClass('alert-danger');
        }

        alert_msg.show();
    }

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    $('#newsletter-form').on('submit', function (event) {
        event.preventDefault();
        let form = $(this);
        let form_el = this;

        // Zamknout tlačítko hned – ochrana proti dvojímu odeslání.
        if (!window.prisahaFormStart(form_el, 'Přihlašuji…')) {
            return;
        }

        alert_msg.hide();
        alert_msg.find('.alert-message').text('');

        let email = this.email.value;
        let recaptcha_response = this.recaptcha_response.value;

        if (!validateEmail(email)) {
            showAlertMessage("Neplatná e-mailová adresa.", false);
            window.prisahaFormEnd(form_el);
            return;
        }

        // AJAX call
        $.ajax({
            type: 'POST', url: MyAjax.ajaxurl, data: {
                action: 'handle_newsletter_form_submission', email: email, nonce: MyAjax.nonce, recaptcha_response: recaptcha_response
            }, success: function (response) {
                if (response.success) {
                    showAlertMessage(response.data, true);
                    form[0].reset();
                    form.hide();
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'form_submit',
                        form:  'newsletter-form',
                        customer: {
                            email: email,
                        }
                    });
                } else {
                    showAlertMessage(response.data, false);
                }
            }, error: function (xhr) {
                let msg = (xhr && xhr.responseJSON && xhr.responseJSON.data)
                    || 'Přihlášení se nepodařilo, zkuste to prosím znovu.';
                showAlertMessage(msg, false);
            }, complete: function () {
                window.prisahaFormEnd(form_el);
            }
        });
    });
});